"use client";
import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import AdvantageComp from "./components/advantages";
import EmpoweringComponent from "./components/empowering";
import OfferingsComponent from "./components/offerings";
import WhyChooseComponent from "./components/whyChoose";
import DifferenceComponent from "./components/difference";
import DeploymentComponent from "./components/deployment";
import CustomerReviewComponent from "./components/customerReview";
import ExtendComponent from "./components/extend";
import UseCasesComponent from "./components/workload";
import ServiceArchitecture from "./components/serviceArchitecture";

const OpenStackCloudPage = () => {
  return (
    <Fragment>
      <Box>
        <Hero />
        <PageLayout>
          <PrivateCloudTabs />
          <Intro />
          <AdvantageComp />
          <EmpoweringComponent />
        </PageLayout>
      </Box>
      <OfferingsComponent />
      <PageLayout>
        <WhyChooseComponent />
        <FeaturesComponent />
        <ServiceArchitecture />
      </PageLayout>
      <DifferenceComponent />
      <PageLayout>
        <DeploymentComponent />
      </PageLayout>
      <UseCasesComponent />
      <PageLayout showContactForm>
        <CustomerReviewComponent />
        <ExtendComponent />
        <Faqs />
      </PageLayout>
    </Fragment>
  );
};

export default OpenStackCloudPage;
